import React from 'react';
import { NodeRenderer } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import MlVideoPlayer from 'components/commercetools-ui/molecules/video-player';

export interface EmbeddedEntryNode {
  data: {
    target: {
      sys: {
        contentType: {
          sys: {
            id: string;
          };
        };
      };
      fields: {
        videoId?: string;
        title?: string;
      };
    };
  };
}

// Type guard to check if a node is an embedded video player.
// Exported so callers can ask whether an embedded entry will actually paint anything —
// every other content type falls through to `null` below.
export const isVideoPlayerNode = (node: unknown): node is EmbeddedEntryNode => {
  if (!node || typeof node !== 'object') return false;
  const n = node as EmbeddedEntryNode;
  return (
    n?.data?.target?.sys?.contentType?.sys?.id === 'videoPlayer' &&
    typeof n?.data?.target?.fields?.videoId === 'string'
  );
};

export const videoPlayerRenderer: Record<string, NodeRenderer> = {
  [BLOCKS.EMBEDDED_ENTRY]: (node) => {
    if (isVideoPlayerNode(node)) {
      const videoId = node.data.target.fields.videoId;
      const title = node.data.target.fields.title;

      if (!videoId) return null;

      return <MlVideoPlayer videoId={videoId} title={title} className="pt-8" />;
    }

    return null;
  },
};
